// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"67":"d7776c0bc3c6d0a83bd3","634":"253a53e1e57d7adb88cb","725":"53ec9825a62633953aed","798":"d5d47322f45003555094","900":"81f3f2717003580dd34e"}[chunkId] + ".js";
};